import axios from "axios";

const fetchBillsWithAmendments = async (billsData) => {
  const limit = 150;
  let amendmentData = [];
  let currentPage = 0;
  let totalPages = 1;
  try {
    while (currentPage < totalPages) {
      const billIds = billsData.map(bill => bill.id);
      const amendmentResponse = await axios.post(
          `${process.env.REACT_APP_LAWS_BACKEND_HOST}/bills/v1//amendments/search?limit=${limit}&offset=${currentPage}`, {
            billIds: billIds
          }
      );

      const billAmendmentData = amendmentResponse.data;
      amendmentData = amendmentData.concat(billAmendmentData.content || []);
      totalPages = billAmendmentData.totalPages;
      currentPage++;
    }

    return billsData.map(bill => ({
      ...bill,
      amendments: amendmentData.filter(amendment => amendment.bill && amendment.bill.id === bill.id) || [],
    }));

  } catch (error) {
    console.error(`Error fetching amendments for bills:`, error);
    throw error;
  }
};

export default fetchBillsWithAmendments;
